import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import './Onboarding.css';

const OnboardingTooltip: React.FC<TooltipRenderProps> = ({
    continuous,
    index,
    step,
    size,
    backProps,
    closeProps,
    primaryProps,
    skipProps,
    tooltipProps,
    isLastStep,
}) => {
    const progress = ((index + 1) / size) * 100;

    return (
        <div {...tooltipProps} className="onb-tooltip">
            {/* Progress bar */}
            <div className="onb-tooltip-progress">
                <div
                    className="onb-tooltip-progress-bar"
                    style={{ width: `${progress}%` }}
                />
            </div>

            {/* Close button */}
            <button {...closeProps} className="onb-tooltip-close" title="Close">
                ✕
            </button>

            {/* Body */}
            <div className="onb-tooltip-body">
                <div className="onb-tooltip-step-counter">
                    Step {index + 1} of {size}
                </div>

                {step.title && (
                    <div className="onb-tooltip-title">{step.title}</div>
                )}

                <p className="onb-tooltip-content">{step.content}</p>
            </div>

            {/* Footer */}
            <div className="onb-tooltip-footer">
                <button {...skipProps} className="onb-tooltip-skip">
                    Skip Tour
                </button>

                <div className="onb-tooltip-nav">
                    {index > 0 && (
                        <button {...backProps} className="onb-tooltip-back">
                            Back
                        </button>
                    )}

                    {continuous && (
                        <button {...primaryProps} className="onb-tooltip-next">
                            {isLastStep ? '✓ Finish' : 'Next →'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OnboardingTooltip;
